export default __webpack_public_path__ + "5f6281f1625ab3a45601583bb1774c58.png";